import { hudPaths } from '../content';
import { AutomationMatrixScreen } from '../sections';
import { PageActionBar } from './PageActionBar';

export const AiAutomationPage = () => {
  return (
    <>
      <AutomationMatrixScreen />
      <PageActionBar activePath={hudPaths.automationSystems} ctaLabel="Transmit AI Workflow Requirements" />
    </>
  );
};
